import { processingSelectData } from '@/utils/index';
import moment from 'moment';

export const MAIN_TYPE = {
  ENTERPRISE: 'ENTERPRISE',
  MERCHANTS: 'MERCHANTS',
};
export const AuthStatus = {
  AUTHED: 'AUTHED',
  NO_AUTH: 'NO_AUTH',
};

export const AuthStatusStyle = {
  AUTHED: '#06B880',
  NO_AUTH: '#F53F3F',
};
export const AuthStatusMap = {
  AUTHED: '已认证',
  NO_AUTH: '未认证',
};
export const source = {
  PLATFORM: 'PLATFORM',
  USER: 'USER',
};
export const sourceMap = {
  PLATFORM: '平台',
  USER: '用户',
};
export const latelyUpdate = {
  1: '最近更新',
  2: '最早更新',
};

// 组织机构搜索字段
export const organizationalSearchField = [
  {
    label: '企业信息',
    prop: 'searchKey',
    formType: 'el-input',
    Attributes: {
      placeholder: '输入企业名称、统一社会信用代码',
      clearable: true,
      maxlength: 50,
    },
  },
  {
    label: '认证状态',
    prop: 'authStatus',
    formType: 'el-select',
    Attributes: {
      placeholder: '请选择认证状态',
      clearable: true,
    },
    subFormType: 'el-option',
    options: processingSelectData({ '': '全部', ...AuthStatusMap }),
  },
  {
    label: '来源',
    prop: 'source',
    formType: 'el-select',
    Attributes: {
      placeholder: '请选择来源',
      clearable: true,
    },
    subFormType: 'el-option',
    options: processingSelectData({ '': '全部', ...sourceMap }),
  },
  // {
  //   label: '最近更新',
  //   prop: 'latelyUpdate',
  //   formType: 'el-select',
  //   Attributes: {
  //     placeholder: '请选择最近更新',
  //   },
  //   subFormType: 'el-option',
  //   options: processingSelectData(latelyUpdate),
  // },
];

// 个体工商户搜索字段
export const individualSearchField = [
  {
    label: '注册信息',
    prop: 'searchKey',
    formType: 'el-input',
    Attributes: {
      placeholder: '输入字号名称,注册号',
      clearable: true,
      maxlength: 50,
    },
  },
  {
    label: '认证状态',
    prop: 'authStatus',
    formType: 'el-select',
    Attributes: {
      placeholder: '请选择认证状态',
      clearable: true,
    },
    subFormType: 'el-option',
    options: processingSelectData({ '': '全部', ...AuthStatusMap }),
  },
  {
    label: '来源',
    prop: 'source',
    formType: 'el-select',
    Attributes: {
      placeholder: '请选择来源',
      clearable: true,
    },
    subFormType: 'el-option',
    options: processingSelectData({ '': '全部', ...sourceMap }),
  },
  // {
  //   label: '最近更新',
  //   prop: 'latelyUpdate',
  //   formType: 'el-select',
  //   Attributes: {
  //     placeholder: '请选择最近更新',
  //   },
  //   subFormType: 'el-option',
  //   options: processingSelectData(latelyUpdate),
  // },
];

// 组织机构列表字段
export const ORGANIZATIONALTABLECOLUMN = (isViewAuthUser) => {
  const authUser = isViewAuthUser ? [{
    label: '认证人',
    prop: 'authUser',
    formatter: (row) => (row.authUser ? `${row.authUser}(${row.authUserPhone})` : '-'),
  }] : [];

  return [
    {
      label: '企业名称',
      prop: 'enterpriseName',
    },
    {
      label: '统一社会信用代码',
      prop: 'creditCode',
    },
    {
      label: '认证状态',
      prop: 'authStatus',
      width: 160,
      formatter: (row) => AuthStatusMap[row.authStatus],
    },
    ...authUser,
    {
      label: '来源',
      prop: 'source',
      formatter: (row) => sourceMap[row.source],
    },
    {
      label: '更新时间',
      prop: 'updateTime',
      formatter: (row) => moment(row.updateTime).format('YYYY-MM-DD HH:mm'),
    },
    {
      label: '更新人',
      prop: 'updateUserName',
    },
    {
      label: '操作',
      prop: 'action',
    },
  ];
};

// 组织机构列表字段
export const INDIVIDUALTABLECOLUMN = (isViewAuthUser) => {
  const authUser = isViewAuthUser ? [{
    label: '认证人',
    prop: 'authUser',
    formatter: (row) => (row.authUser ? `${row.authUser}(${row.authUserPhone})` : '-'),
  }] : [];
  return [
    {
      label: '字号名称',
      prop: 'enterpriseName',
    },
    {
      label: '注册号',
      prop: 'creditCode',
    },
    {
      label: '认证状态',
      prop: 'authStatus',
      width: 160,
      formatter: (row) => AuthStatusMap[row.authStatus],
    },
    ...authUser,
    {
      label: '来源',
      prop: 'source',
      formatter: (row) => sourceMap[row.source],
    },
    {
      label: '更新时间',
      prop: 'updateTime',
      formatter: (row) => moment(row.updateTime).format('YYYY-MM-DD HH:mm'),
    },
    {
      label: '更新人',
      prop: 'updateUserName',
    },
    {
      label: '操作',
      prop: 'action',
    },
  ];
};

// 组织机构新增详情字段
export const organizationalField = {
  edit: [
    {
      label: '企业名称',
      prop: 'enterpriseName',
      slot: 'enterpriseName',
      colSpan: 16,
      rules: [{ required: true, message: '企业名称不能为空', trigger: 'blur' }],
    },
    {
      label: '统一社会信用代码',
      prop: 'creditCode',
      slot: 'creditCode',
      colSpan: 16,
      rules: [
        { required: true, message: '统一社会信用代码不能为空', trigger: 'blur' },
        { pattern: /^[A-Za-z0-9]+$/, message: '请输入正确的统一社会信用代码', trigger: 'blur' },
      ],
    }],
  details: [
    {
      label: '企业名称',
      prop: 'enterpriseName',
      colSpan: 16,
      type: 'text',
    },
    {
      label: '统一社会信用代码',
      prop: 'creditCode',
      colSpan: 16,
      type: 'text',
    },
    {
      label: '认证状态',
      prop: 'authStatus',
      colSpan: 16,
      type: 'text',
      textFormatter: (row) => `<span style="color:${AuthStatusStyle[row.authStatus]}">${AuthStatusMap[row.authStatus]}</span>`,
    },
  ],
};
export const authInfoField = {
  label: '认证信息',
  prop: 'authInfo',
  colSpan: 16,
  type: 'text',
  textFormatter: (row) => `<div style="display:flex;flex-direction: column;"><span>${row.authUser || ''}</span><span>${row.authUserIdCard || ''}</span><span>${row.authUserPhone || ''}</span></div>`,
};
// 个体工商户新增详情字段
export const individualField = {
  edit: [
    {
      label: '字号名称',
      prop: 'enterpriseName',
      slot: 'enterpriseName',
      colSpan: 16,
      rules: [{ required: true, message: '字号名称不能为空', trigger: 'blur' }],
    },
    {
      label: '注册号',
      prop: 'creditCode',
      slot: 'creditCode',
      colSpan: 16,
      rules: [
        { required: true, message: '注册号不能为空', trigger: 'blur' },
        { pattern: /^[A-Za-z0-9]+$/, message: '请输入正确的统一社会信用代码', trigger: 'blur' },
      ],
    },
  ],
  details: [
    {
      label: '字号名称',
      prop: 'enterpriseName',
      colSpan: 16,
      type: 'text',
    },
    {
      label: '注册号',
      prop: 'creditCode',
      colSpan: 16,
      type: 'text',
    },
    {
      label: '认证状态',
      prop: 'authStatus',
      colSpan: 16,
      type: 'text',
      textFormatter: (row) => `<span style="color:${AuthStatusStyle[row.authStatus]}">${AuthStatusMap[row.authStatus]}</span>`,
    },
    // {
    //   label: '认证信息',
    //   prop: 'authInfo',
    //   colSpan: 16,
    //   type: 'text',
    //   textFormatter: () => '<div>dsadsadadsa</div><div>dsadsadadsa</div><div>dsadsadadsa</div><div>dsadsadadsa</div>',
    // },
  ],
};

// 授权列表字段
export const AUTHTABLECOLUMN = [
  {
    label: '客户编码',
    prop: 'customerCode',
  },
  {
    label: '客户简称',
    prop: 'customerShortName',
  },
  {
    label: '客户全称',
    prop: 'customerName',
    width: 160,
  },
  {
    label: '操作',
    prop: 'action',
  },
];

// 添加授权左侧列表
export const LEFTAUTHTABLECOLUMN = [
  {
    label: '客户编码',
    prop: 'customerCode',
  },
  {
    label: '客户简称',
    prop: 'customerName',
  },
];

// 添加授权右侧列表
export const RIGHTAUTHTABLECOLUMN = [
  {
    label: '客户编码',
    prop: 'customerCode',
  },
  {
    label: '客户简称',
    prop: 'customerName',
  },
  {
    label: '操作',
    prop: 'action',
  },
];
